import React from "react";
import List from "devextreme-react/list";

const ListLayout = ({ lists, displayName, onSelectedItemsChange }) => {
  return (
    <div className="list-layout">
      <h4>Search Result</h4>
      <List
        dataSource={lists}
        height={lists && lists.length >= 7 ? 250 : "auto"}
        displayExpr={displayName}
        showSelectionControls={true}
        selectionMode="single"
        searchExpr={displayName}
        searchEnabled={true}
        searchMode="contains"
        onOptionChanged={onSelectedItemsChange}
      ></List>
    </div>
  );
};

export default ListLayout;
